import React, { useState, useEffect }from 'react'
import PhoneContext from './PhoneContext'
import PhoneInputField from './PhoneInputField'
import RegisterPhoneInput from './RegisterPhoneInput'
import PhoneErrors from './PhoneErrors'

const PhoneVerification = ({ children }) => {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneUnique, setPhoneUnique] = useState(null)
  const [verificationStatus, setVerificationStatus] = useState('')
  const [errorMessage, setErrorMessage] = useState(null)

  useEffect(() => {
    if (verificationStatus !== 'failed') return

    const failTimer = setTimeout(() => {
      setVerificationStatus('')
      setErrorMessage(null)
    }, 5000);

    return () => {
      clearTimeout(failTimer);
    };
  }, [verificationStatus])

  useEffect(() => {
    if (phoneNumber) return

    setPhoneUnique(null)
  }, [phoneNumber])

  return (
    <PhoneContext.Provider
      value={{
        phoneNumber,
        phoneUnique,
        verificationStatus,
        errorMessage,
        setVerificationStatus,
        setPhoneNumber,
        setPhoneUnique,
        setErrorMessage
      }}
    >
      {children}
    </PhoneContext.Provider>
  )
}

PhoneVerification.Input = PhoneInputField
PhoneVerification.RegisterInput = RegisterPhoneInput
PhoneVerification.Errors = PhoneErrors

export default PhoneVerification
